var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg310311Dn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 55,
    height: 53,
    viewBox: "0 0 55 53",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -2)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 55,
    height: 55
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009EFF",
    d: "M36.844,45.229 C35.521,47.783 32.502,46.112 33.772,43.647 C34.85,41.552 37.44,40.285 37.44,40.285 C37.44,40.285 37.89,43.201 36.844,45.229 Z M29.848,52.838 C28.525,55.392 25.506,53.721 26.776,51.256 C27.854,49.161 30.444,47.894 30.444,47.894 C30.444,47.894 30.894,50.809 29.848,52.838 Z M23.646,45.229 C22.323,47.783 19.304,46.112 20.574,43.647 C21.652,41.552 24.242,40.285 24.242,40.285 C24.242,40.285 24.692,43.201 23.646,45.229 Z M16.826,52.838 C15.503,55.392 12.484,53.721 13.754,51.256 C14.832,49.161 17.422,47.894 17.422,47.894 C17.422,47.894 17.873,50.809 16.826,52.838 Z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    opacity: 0.4,
    transform: "translate(0 -2)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 55,
    height: 55,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#C9C9C9",
    strokeWidth: 1.4,
    d: "M6.06 29.503L45.192 29.503M11.689 39.708L50.821 39.708M4.561 24.401L43.519 24.401M9.762 34.606L48.72 34.606M6.06 9.093L45.192 9.093M11.689 19.298L50.821 19.298M4.561 3.99L43.519 3.99M10.29 14.16L49.248 14.16M4.561 45.097L43.519 45.097"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg310311Dn);
export default __webpack_public_path__ + "static/media/310_311dn.8e06b7fdf15a5148f83496c2307c2cf9.svg";
export { ForwardRef as ReactComponent };